import {
  toNumberLocaleString,
} from '../modules/localeString.js'

export default {
  computed: {
    numberLocaleString(value) {
      return toNumberLocaleString(value)
    }
  }
}
